import { useCallback, useMemo } from 'react'

import { useNavigate } from 'react-router'
import { usePermission, useSelectedTrial } from 'src/features/auth/context'
import { swrKeys } from 'src/legacy_modules/swr/key'
import { PERMISSIONS } from 'src/lib/permission'
import useSWR from 'swr'

import { useIcfDocumentHospital } from '../../use-icf-document-hospital'
import { fetchIcfDocumentSetList } from '../request'
import {
  getAddIcfDocumentSetRoute,
  getIcfDocumentSetDetailRoute,
} from './../../routes'

export const useIcfDocumentSetList = () => {
  const { selectedTrialHospitalUid } = useIcfDocumentHospital()
  const { selectedTrial } = useSelectedTrial()
  const { uid: trialUid } = selectedTrial
  const navigate = useNavigate()
  const { hasPermission } = usePermission()

  const { data: icfDocumentSetList } = useSWR(
    selectedTrialHospitalUid
      ? swrKeys.fetchIcfDocumentSetList({
          trialUid,
          trialHospitalUid: selectedTrialHospitalUid,
        })
      : null,
    () =>
      fetchIcfDocumentSetList({
        trialUid,
        trialHospitalUid: selectedTrialHospitalUid ?? '',
      }),
  )

  const canAddDocumentSet = useMemo(
    () => hasPermission(PERMISSIONS.Icfdocumentset_Create),
    [hasPermission],
  )

  const navigateToAdd = useCallback(() => {
    navigate(
      getAddIcfDocumentSetRoute({
        trialUid,
        trialHospitalUid: hasPermission(
          PERMISSIONS.Icfdocument_SelectTrialHospital,
        )
          ? selectedTrialHospitalUid
          : undefined,
      }),
    )
  }, [navigate, trialUid, hasPermission, selectedTrialHospitalUid])

  const navigateToDetail = useCallback(
    (icfDocumentSetUid: string) => {
      navigate(
        getIcfDocumentSetDetailRoute({
          trialUid,
          icfDocumentSetUid,
          trialHospitalUid: hasPermission(
            PERMISSIONS.Icfdocument_SelectTrialHospital,
          )
            ? selectedTrialHospitalUid
            : undefined,
        }),
      )
    },
    [navigate, trialUid, hasPermission, selectedTrialHospitalUid],
  )

  return {
    icfDocumentSetList,
    canAddDocumentSet,
    navigateToAdd,
    navigateToDetail,
  }
}
